import { useRouter } from 'next/router';

import { PharmacyPickupService } from '@/services/pharmacy/PharmacyPickupService';
import { EPharmacyViewType, PharmacySearchParamsQueries, PharmacySearchQueries } from '@/types/pharmacy';
import { updateSearchParams } from '@/utils/url';

interface IUsePharmacyViewType {
  pharmacyViewType: EPharmacyViewType;
  shouldShowListView: boolean;
  toggleViewMode: () => void;
}

const usePharmacyViewType = (): IUsePharmacyViewType => {
  const router = useRouter();
  const { viewType } = router.query as PharmacySearchQueries;
  const pharmacyViewType = PharmacyPickupService.getPharmacyViewType(viewType);
  const shouldShowListView = pharmacyViewType === EPharmacyViewType.List;

  const toggleViewMode = () => {
    updateSearchParams([
      {
        key: PharmacySearchParamsQueries.ViewType,
        value: pharmacyViewType === EPharmacyViewType.Map ? EPharmacyViewType.List : EPharmacyViewType.Map,
      },
    ]);
  };

  return {
    pharmacyViewType,
    shouldShowListView,
    toggleViewMode,
  };
};

export default usePharmacyViewType;
